module.exports = __webpack_public_path__ + "static/media/location_image3.abca63f5.jpg";